import ufeApi from 'services/api/ufeApi';
import headerUtils from 'utils/Headers';
import userUtils from 'utils/User';

const { purchaseEventTimeStamp } = headerUtils;

// Attaches Google Pay via the credit-card endpoint; SDN converts the top-level
// `googlePay` wrapper to a GraphQL addPayment(googlePay) mutation. This is
// different from the other alternate payment methods
//
// `config` is forwarded to ufeApi.makeRequest so callers can opt into
// `abortable: true` — the Google Pay onPaymentAuthorized handler passes it so it
// can cancel this in-flight authorization
async function initializeGooglePayCheckout(googlePay, config = {}) {
    const url = '/api/checkout/orders/creditCard';

    const headers = {
        ...purchaseEventTimeStamp()
    };

    userUtils.insertSAZipCodeSACountryCodeHeaders(headers);

    const data = await ufeApi.makeRequest(
        url,
        {
            method: 'POST',
            headers,
            body: JSON.stringify({ googlePay })
        },
        config
    );

    if (data.errorCode) {
        throw data;
    }

    return data;
}

export default initializeGooglePayCheckout;
